import { render, staticRenderFns } from "./LinkPayBizumForm.vue?vue&type=template&id=46d66242&"
import script from "./LinkPayBizumForm.vue?vue&type=script&lang=ts&"
export * from "./LinkPayBizumForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports